import type React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@roger/ui-components';
import type { RogerDocClinicianAccount } from '../../../services/accountLinkApi';
import { RogerDocAccountSection } from '../RogerDocAccountSection';
import type { OrgMemberResponse } from '../types';
import { memberDisplayName } from './clinicSetup';

/** One member's Roger App accounts, opened from the App accounts cell. */
export const MemberAppAccountsDialog: React.FC<{
  member: OrgMemberResponse;
  /** The agency's accounts the page already holds, shown at once. */
  accounts?: RogerDocClinicianAccount[];
  /** The list after each link, unlink or reload, so the grid shows it at once. */
  onAccountsChange: (accounts: RogerDocClinicianAccount[]) => void;
  /** Reloads the page's list when a call ends after the dialog has closed. */
  onChanged: () => void;
  onClose: () => void;
  onCloseAutoFocus: (event: Event) => void;
}> = ({
  member,
  accounts,
  onAccountsChange,
  onChanged,
  onClose,
  onCloseAutoFocus,
}) => (
  <Dialog open onOpenChange={open => !open && onClose()}>
    <DialogContent
      className='flex max-h-[85vh] flex-col sm:max-w-2xl'
      onCloseAutoFocus={onCloseAutoFocus}
    >
      <DialogHeader>
        <DialogTitle>{memberDisplayName(member)}</DialogTitle>
      </DialogHeader>
      <div className='-mr-2 min-h-0 flex-1 overflow-y-auto pr-2'>
        <RogerDocAccountSection
          member={member}
          onAccountsChange={onAccountsChange}
          onChanged={onChanged}
          initialAccounts={accounts}
          collapsible={false}
          inDialog
        />
      </div>
    </DialogContent>
  </Dialog>
);
